// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hO0yt","tooltip":"style_tooltip__m834F","diseases":"style_diseases__Xhnyf","disease":"style_disease__IpD88"};